import type { RecommendedQuestionGraphQL } from '../../../graphql/type';
import type { SelectionTypeView } from '../../../sdk';

export type AvailableAnswerOrders = Record<string, number>;

// 'Search' source is only being used in the UI
export const QuestionSourceState = {
  Library: 'Library',
  Custom: 'Custom',
  Search: 'Search',
} as const;

export type QuestionSourceState =
  (typeof QuestionSourceState)[keyof typeof QuestionSourceState];

export interface Question extends Omit<RecommendedQuestionGraphQL, 'source'> {
  source: QuestionSourceState; // override source with custom type for UI state
  preferredAnswers: { [key in SelectionTypeView]: string[] };
  lastInteraction?: string;
  availableAnswerOrders: AvailableAnswerOrders;
}

export type Settings = Partial<{
  questionSectionHeading: boolean;
  showCertsyTooltip: boolean;
}>;

export interface State {
  questions: Record<string, Question>;
  versionNumber: string | null;
  selectionLimit: number;
  customQuestionsSelectionLimit: number;
  firstInteraction: boolean;
  showQuestions: boolean;
  settings: Settings;
  published?: boolean;
  questionnaireHasQuestions?: boolean;
  bundlingQuestionCategory?: string;
}
